var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"o-edition-section-navigation"},[_c('MoleculeEditionSectionNavigationMenu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }